<template>
  <div class="mbr-keypad" role="group" :aria-label="$t('passcode.number_pad')">
    <template v-for="key in keys" :key="key">
      <span v-if="key === ''" aria-hidden="true"></span>
      <button
        v-else
        type="button"
        class="mbr-keypad__key"
        :aria-label="key === 'backspace' ? $t('passcode.delete') : key"
        @mousedown.prevent
        @click="press(key)"
      >
        <svg
          v-if="key === 'backspace'"
          class="mbr-keypad__icon"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M12 9.75L14.25 12m0 0l2.25 2.25M14.25 12l2.25-2.25M14.25 12L12 14.25m-2.58 4.92l-6.375-6.375a1.125 1.125 0 010-1.59L9.42 4.83c.211-.211.498-.33.796-.33H19.5a2.25 2.25 0 012.25 2.25v10.5a2.25 2.25 0 01-2.25 2.25h-9.284c-.298 0-.585-.119-.796-.33z"
          />
        </svg>
        <template v-else>{{ key }}</template>
      </button>
    </template>
  </div>
</template>

<script>
// On-screen number pad for PasscodePin. It types into the focused PIN, or the
// last focused one when focus has moved away; mousedown.prevent keeps focus
// (and so the active box) on the PIN while a key is tapped.
export default {
  name: "PasscodeKeypad",
  data() {
    return {
      keys: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "", "0", "backspace"],
    };
  },
  methods: {
    press(key) {
      const active = document.activeElement;
      const target = active && active.classList.contains("mbr-pin__input")
        ? active
        : document.querySelector(".mbr-pin__input[data-pin-last]") || document.querySelector(".mbr-pin__input");
      if (!target) return;
      if (target !== active) target.focus();
      target.dispatchEvent(new CustomEvent("pin-key", { detail: key }));
    },
  },
};
</script>

<style scoped>
.mbr-keypad {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  width: 100%;
  max-width: 342px;
  margin: 0 auto;
}

.mbr-keypad__key {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 56px;
  margin: 0;
  padding: 0;
  border: 0;
  border-radius: var(--mbr-radius-lg);
  background: var(--mbr-color-tint);
  font-family: var(--mbr-font-headline);
  font-size: 24px;
  font-weight: 700;
  line-height: 1;
  color: var(--mbr-color-ink-headline);
  transition: background-color 0.15s ease, transform 0.15s ease;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
}

.mbr-keypad__key:active {
  background: var(--mbr-color-tint-dark);
  transform: scale(0.95);
}

.mbr-keypad__icon {
  width: 28px;
  height: 28px;
}
</style>
